import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Arrow from "../components/Arrow"
import { scrollDiv } from '../Helpers'

const BlockLastProjects = () => {

   const data = useStaticQuery(graphql`
       query {
           allWpPost(limit: 5) {
               nodes {
                   id
                   title
                   slug
                   ratgeber {
                       projCover {
                           altText
                           srcSet
                       }
                   }
               }
           }
       }
   `)

   if (data.allWpPost) {

       const projects = data.allWpPost.nodes

       var colors = {
           1: {"block": "bg-rekord-orange", "text": "text-white", "arrow": "#fff"},
           2: {"block": "bg-rekord-lorange", "text": "text-black", "arrow": "#000"},
           3: {"block": "bg-rekord-dorange", "text": "text-white","arrow": "#fff"},
           4: {"block": "bg-rekord-lgreen", "text": "text-black", "arrow": "#000"},
           5: {"block": "bg-rekord-lgray", "text": "text-black", "arrow": "#000"}
       }

       return (
           <section className="bg-white block-products-categories">
               <div className="container mx-auto py-16 lg:py-24">
                   <h3 className="uppercase block mb-12 text-lg font-normal">Ratgeber</h3>
                   <div className="flex flex-col md:flex-row mb-6 gap-6 md:gap-0 justify-between items-start md:items-center">
                       <span className="font-bold text-2xl lg:text-4xl pl-6 lg:px-24 pb-6">
                           Die letzten Beiträge
                       </span>
                       <div className="w-full flex justify-end">
                           <Link to="/ratgeber" className="block btn btn-green" title="Rekord Fenster | Ratgeber">
                               alle Artikel
                           </Link>
                       </div>
                   </div>
                   <div className="relative">
                       <div id="projectsList" className="overflow-x-auto overflow-y-hidden scroll-smooth whitespace-nowrap">
                           {projects && projects.map((proj, i, row) => {
                              return (
                                  <article key={i} className={i + 1 === row.length ? 'h-full inline-flex flex-col mb-8 w-full md:w-1/2 lg:w-1/4 whitespace-normal' : 'h-full inline-flex flex-col mb-8 mr-4 w-full md:w-1/2 lg:w-1/4 whitespace-normal'}>
                                      <Link to={'/ratgeber/' + proj.slug} title={'Rekord Fenster | ' + proj.title}>
                                          {proj.ratgeber.projCover ?
                                             <div className="block h-72 w-full">
                                                <img className="w-full h-full object-cover" srcSet={proj.ratgeber.projCover.srcSet} alt={proj.ratgeber.projCover.altText} sizes="(max-width: 384px) 100vw, 384px" />
                                             </div>
                                          : ''}
                                      </Link>
                                      <div className={colors[(i+1)].block + ' p-6 h-60 flex flex-col justify-end'}>
                                          <Link className="no-underline" to={'/ratgeber/' + proj.slug} title={'Rekord Fenster | ' + proj.title}>
                                              <h1 className={colors[(i+1)].text + ' block mt-4 mb-2 text-2xl font-light no-underline'}>{proj.title}</h1>
                                              <Arrow color={colors[(i+1)].arrow} />
                                          </Link>
                                      </div>
                                  </article>
                               )
                           })}
                       </div>
                       <div className="flex justify-end pt-6">
                           <button onClick={() => { scrollDiv('projectsList', 'left', projects.length)}}>
                               <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                   <g id="Pfeil" transform="translate(32.621)">
                                       <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H-29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3"/>
                                       <path id="Fill_12" data-name="Fill 12" d="M-2.047,24.543,0,22.344-10.838,12.273,0,2.2-2.047,0l-13.2,12.273Z" transform="translate(-17.378)"/>
                                   </g>
                               </svg>
                           </button>
                           <button className="ml-2" onClick={() => { scrollDiv('projectsList', 'right', projects.length)}}>
                               <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                   <g id="Pfeil" transform="translate(0)">
                                       <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3"/>
                                       <path id="Fill_12" data-name="Fill 12" d="M2.047,24.543,0,22.344,10.838,12.273,0,2.2,2.047,0l13.2,12.273Z" transform="translate(17.378)"/>
                                   </g>
                               </svg>
                           </button>
                       </div>
                   </div>
               </div>
           </section>
       )
   }
}

export default BlockLastProjects
